import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import cn from 'classnames';
import { List, ListItem, ListItemIcon, ListItemText, SwipeableDrawer, type Theme } from '@mui/material';
import { RoutePaths } from '@shared';
import { RouterNavLink } from '@widgets';
import { SidebarLogo } from './components';
import { useStyles } from './styles';

interface Props {
  open: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const Sidebar = (props: Props) => {
  const theme = useTheme<Theme>();
  const classes = useStyles();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));

  const routes = useMemo(() => RoutePaths.getRoutes(), []);

  const location = useLocation();

  useEffect(() => {
    if (isLg && props.open) props.closeDrawer();
  }, [isLg, props.open, props.closeDrawer]);

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <SwipeableDrawer
      anchor='left'
      ModalProps={{ keepMounted: true }}
      variant={isLg ? 'permanent' : 'temporary'}
      open={isLg || props.open}
      onClose={props.closeDrawer}
      onOpen={props.openDrawer}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      classes={{ paper: classes.drawer }}
    >
      <List dense className={classes.list}>
        {routes.map(({ path, icon: Icon, title }) => (
          <ListItem
            key={path}
            className={cn(classes.item, location.pathname.includes(`/${path}`) && classes.itemActive)}
            component={RouterNavLink}
            to={path}
            button
            onClick={props.closeDrawer}
          >
            <ListItemIcon className={classes.itemIcon}>{Icon && <Icon />}</ListItemIcon>
            <ListItemText secondary={title} secondaryTypographyProps={{ className: classes.itemText }} />
          </ListItem>
        ))}
      </List>
      <SidebarLogo text='IPP' />
    </SwipeableDrawer>
  );
};
